import React from 'react';
import { Box, CircularProgress, CircularProgressProps, styled } from '@mui/material';

const CenteringBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 50%);
`;

export const CenteredCircularProgress = React.forwardRef<HTMLSpanElement, CircularProgressProps>(
  function CenteredCircularProgress(props, ref) {
    return (
      <CenteringBox>
        <CircularProgress {...props} ref={ref} />
      </CenteringBox>
    );
  }
);
